<template>
    <div class="multi-input-item-wrapper">
        <div
            v-for="(item, index) in items"
            :key="item.name"
            class="multi-input-item"
            :class="{ 'multi-input-item-last': index + 1 === items.length }"
            :style="item.extendProps.styles || { width: styleWidth }"
        >
            <component
                :is="item.type"
                :value="value[item.name]"
                v-bind="{ ...item.extendProps, ...(relatedItems[item.name] || {}) }"
                @change="inputChange(item, $event)"
                @input="inputChange(item, $event)"
                @init="initChange(item, $event)"
            >
            </component>
        </div>
        <i class="el-icon-remove icon" v-show="!only" @click="deleteItem"></i>
        <i class="el-icon-circle-plus icon" v-show="hasAdd" @click="addItem"></i>
    </div>
</template>

<script>
export default {
    name: 'InputItem',
    model: {
        prop: 'value',
        event: 'change',
    },
    props: {
        items: {
            type: Array,
            default() {
                return [];
            },
        },
        width: {
            type: String,
            default() {
                return undefined;
            }
        },
        value: {
            type: Object,
            default() {
                return {};
            },
        },
        hasAdd: {
            type: Boolean,
            default() {
                return false;
            },
        },
        only: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },
    data() {
        return {
            relatedItems: {},
        };
    },
    computed: {
        styleWidth() {
            return this.width || this.width || `${90 / this.items.length}%`;
        }
    },
    watch: {
        items(newVal) {
            newVal.forEach((item) => {
                if (this.value[item.name] && item.trigger) {
                    this.trggerRelateFields(item, this.value, true);
                }
            });
        },
    },
    methods: {
        initChange(item, value) {
            const newValue = { ...this.value, ...{ [item.name]: value } };
            this.trggerRelateFields(item, newValue, true);
            this.$emit('change', newValue);
        },
        inputChange(item, value) {
            const newValue = { ...this.value, ...{ [item.name]: value } };
            if (item.type === "el-input") {
                newValue[item.name] = value.replace(/[ ]/g, "");
            }

            this.trggerRelateFields(item, newValue);
            this.$emit('change', newValue);
        },
        trggerRelateFields(item, newValue, isInit) {
            if (item.trigger) {
                item.trigger.forEach((targetItemName) => {
                    this.items.some((i) => {
                        if (i.name !== targetItemName) {
                            return false;
                        }
                        if (!isInit && i.defaultData) {
                            i.defaultData(newValue); // 当依赖改变时，重新设置组件当前的取值
                        }
                        this.relatedItems[i.name] = i.triggerAction(newValue, isInit); // 更改组件属性默认值
                        return true;
                    });
                });
            }
        },
        deleteItem() {
            this.$emit('delete');
        },
        addItem() {
            this.$emit('add');
        },
    },
};
</script>

<style lang="less" scoped>
.multi-input-item {
    display: inline-block;
    padding-right: 8px;
    box-sizing: border-box;
}
.multi-input-item-last {
    padding-right: 0;
}
.icon {
    font-size: 18px;
    cursor: pointer;
    display: none;
}

.multi-input-item-wrapper {
    &:hover {
        .icon {
            display: inline-block;
        }
    }
}
</style>
